<template>
  <div>
    <vx-card
      title="Фильтры"
      class="p-1 mb-3 passes__filter-card"
      style="background: #e3e6fd"
      collapseAction
    >
      <div class="flex flex-wrap items-center justify-start w-full">
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            :options="countItemsOmPage"
            :clearable="false"
            v-model="countElements"
            style="background-color: #fff"
            placeholder="Количество адресов"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterCounters"
            label="name"
            :options="meterType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.kind"
            placeholder="Тип счетчика"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterCounters"
            label="name"
            :options="counterStatus"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.status"
            placeholder="Статус счетчика"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер счетчика"
            v-model="filter.counter_number__icontains"
          />
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filter.home__homestead_number"
          />
        </div>

        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            placeholder="Сортировка"
            @input="filterCounters"
            label="name"
            :options="orderingData"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.ordering"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </div>
    </vx-card>

    <vx-card :title="`Счетчики | Всего ${totalCounters}`" class="p-6">
      <vs-table
        :data="counters"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Данные плательщика </vs-th>
          <vs-th> # счетчика </vs-th>
          <vs-th> Тип счетчика </vs-th>
          <vs-th> Показания </vs-th>
          <vs-th> Статус </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="mb-2">
                Адрес:
                <span class="text-primary">{{
                  data[indextr].home.county_type.name
                }}</span
                >, участок #
                <span class="text-primary">{{
                  data[indextr].home.homestead_number
                }}</span
                >, ул.
                <span class="text-primary">{{
                  data[indextr].home.address
                }}</span>
              </p>
            </vs-td>

            <vs-td>
              {{ data[indextr].counter_number }}
            </vs-td>

            <vs-td>
              {{ data[indextr].kind.name }}
            </vs-td>

            <vs-td>
              <template v-if="data[indextr].indications.length">
                <p
                  v-for="(indication, index) in data[indextr].indications"
                  :key="index"
                  class="mb-2"
                >
                  <template v-if="data[indextr].kind.id == 'electricity'">
                    {{ indication.ind_price.kind }}:
                    <span class="text-primary font-bold">{{
                      indication.indication
                    }}</span>
                  </template>
                  <template v-else-if="data[indextr].kind.id == 'cold_water'">
                    <span class="text-primary font-bold"
                      >{{ indication.indication }} м³</span
                    >
                  </template>
                </p>
                <p>
                  Дата передачи показаний:
                  <span class="">{{
                    data[indextr].indications[0].date_created
                  }}</span>
                </p>
              </template>
              <template v-else>
                <span>Показания не передавались</span>
              </template>
            </vs-td>

            <vs-td>
              <span
                v-if="data[indextr].status"
                :class="{
                  'text-success': data[indextr].status.id == 'work',
                  'text-warning': data[indextr].status.id == 'change',
                  'text-danger': data[indextr].status.id == 'off',
                }"
              >
                {{ data[indextr].status.name }}
              </span>
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block mr-3" text="Передать показания">
                <vs-button
                  @click="openSendIndication(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-upload-cloud"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip
                class="inline-block mr-3"
                text="Редактировать счетчик"
              >
                <vs-button
                  @click="openEditCounter(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip class="inline-block" text="Удалить счетчик">
                <vs-button
                  @click="openDeleteCounter(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>

    <vs-popup
      v-if="activeSendIndicators"
      title="Обновить показания"
      :active.sync="activeSendIndicators"
      v-on:close="clearNewIndication"
    >
      <div class="loading-wrap vs-con-loading__container">
        <template v-if="newIndication.kind == 'electricity'">
          <vs-input
            class="w-full mb-4"
            v-validate="'required'"
            data-vv-validate-on="blur"
            label="Показания T1"
            name="Показания T1"
            type="number"
            v-model.number="newIndication.indications.T1"
          />
          <span class="text-danger text-sm">{{
            errors.first("Показания T1")
          }}</span>

          <vs-input
            class="w-full mb-4"
            v-validate="'required'"
            data-vv-validate-on="blur"
            label="Показания T2"
            name="Показания T2"
            type="number"
            v-model.number="newIndication.indications.T2"
          />
          <span class="text-danger text-sm">{{
            errors.first("Показания T2")
          }}</span>

          <vs-input
            class="w-full mb-4"
            v-validate="'required'"
            data-vv-validate-on="blur"
            label="Показания T3"
            name="Показания T3"
            type="number"
            v-model.number="newIndication.indications.T3"
          />
          <span class="text-danger text-sm">{{
            errors.first("Показания T3")
          }}</span>
        </template>
        <template v-else-if="newIndication.kind == 'cold_water'">
          <vs-input
            class="w-full mb-4"
            v-validate="'required'"
            data-vv-validate-on="blur"
            label="Показания"
            name="Показания"
            type="number"
            v-model.number="newIndication.indications.cold_water"
          />
          <span class="text-danger text-sm">{{
            errors.first("Показания")
          }}</span>
        </template>

        <div class="popup-footer mt-4">
          <vs-button
            @click="sendIndication"
            class="mr-5 vs-con-loading__container"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Добавить</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      v-if="counter && homes"
      title="Изменить счетчик"
      :active.sync="popupEditCounter"
      v-on:close="clearCounter"
    >
      <vs-input
        class="w-full mb-4"
        label="Номер счетчика"
        name="Номер счетчика"
        v-model="counter.counter_number"
      />

      <v-select
        label="name"
        :options="counterStatus"
        v-model="counter.status"
        :clearable="false"
        placeholder="Статус счетчика"
        class="mb-4"
      >
        <div slot="no-options">Совпадений не найдено</div>
      </v-select>

      <vs-divider />

      <p class="font-semibold mb-5">Выберите участок</p>

      <div class="flex flex-wrap items-center justify-between w-full">
        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filterForHomes.homestead_number"
          />
        </div>

        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterHomes"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filterForHomes.county_type"
            placeholder="Выбор поселения"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </div>

      <vs-table
        :data="homes"
        v-model="counter.home"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Участок </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            :state="ifHomeSelected(tr.id) ? null : 'success'"
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              <span class="text-primary">{{ tr.county_type.name }}</span
              >, участок #
              <span class="text-primary">{{ tr.homestead_number }}</span
              >, ул. <span class="text-primary">{{ tr.address }}</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        v-if="totalPagePaginationHomes > 1"
        class="mt-4"
        :total="totalPagePaginationHomes"
        v-model="currentPagingationPageHomes"
      ></vs-pagination>

      <vs-divider />

      <vs-button @click="updateCounter" type="relief">Обновить</vs-button>
    </vs-popup>

    <vs-popup
      v-if="counter"
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
      v-on:close="clearCounter"
    >
      <p class="font-semibold mb-5">
        Счетчик
        <span class="text-danger"> {{ counter.counter_number }}</span> будет
        удален безвозвратно
      </p>
      <vs-button
        @click="deleteCounter"
        color="danger"
        class="mr-5"
        type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import {
  API_URL,
  countyType,
  meterType,
  countItemsOmPage,
  counterStatus,
} from "@/.env";
import { DateTime } from "luxon";

export default {
  data: () => ({
    BASE_URL: API_URL,
    counters: [],
    activeSendIndicators: false,
    newIndication: null,
    filter: {
      kind: "",
      home__homestead_number: "",
      counter_number__icontains: "",
      status: "work",
    },

    filterForHomes: {
      homestead_number: "",
      county_type: "",
    },
    homes: null,
    totalHomes: 0,
    totalPagePaginationHomes: 1,
    currentPagingationPageHomes: 1,

    counter: null,

    countElements: 20,
    currentPagingationPage: 1,
    totalCounters: 0,
    totalPagePagination: 1,
    countItemsOmPage,

    popupDeleteComfirm: false,
    popupEditCounter: false,

    countyType,
    meterType,
    counterStatus,

    orderingData: [
      { id: "date_last", name: "↑Дата показаний" },
      { id: "-date_last", name: "↓Дата показаний" },
    ],
  }),
  components: {},
  watch: {
    filter: {
      handler(val) {
        this.filterCounters();
        this.currentPagingationPage = 1;
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getCounters();
    },
    currentPagingationPage: function () {
      this.getCounters();
    },

    //Homes
    filterForHomes: {
      handler(val) {
        this.filterHomes();
      },
      deep: true,
    },
    currentPagingationPageHomes: function () {
      this.getHomes();
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    filterCounters: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getCounters();
    }, 1000),
    openSendIndication(meterID) {
      let meter = this.counters.find((x) => x.id == meterID);
      let payload = {
        counter_number: meter.counter_number,
        homestead_number: meter.home.homestead_number,
        kind: meter.kind.id,
        indications: {},
      };

      if (meter.indications.length > 0) {
        meter.indications.forEach((indication) => {
          if (meter.kind.id == "electricity") {
            payload.indications[indication.ind_price.kind] =
              indication.indication;
          } else if (meter.kind.id == "cold_water") {
            payload.indications["cold_water"] = indication.indication;
          }
        });
      } else {
        if (meter.kind.id == "electricity") {
          payload.indications = {
            T1: 0,
            T2: 0,
            T3: 0,
          };
        } else if (meter.kind.id == "cold_water") {
          payload.indications = {
            cold_water: 0,
          };
        }
      }

      this.newIndication = payload;
      this.activeSendIndicators = true;
    },
    sendIndication() {
      this.$load(async () => {
        await this.$api.counters
          .updateIndication(this.newIndication)
          .then((response) => {
            this.notification("Успешно", "Данные обновлены", "success");
          })
          .catch((error) => {
            this.notification("Ошибка", "Данные не удалось обновить", "danger");
          });

        this.activeSendIndicators = false;
      });
    },
    getCounters() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        await this.$api.counters
          .getCounters(this.filter)
          .then((response) => {
            this.totalCounters = response.data.count;
            this.totalPagePagination = Math.ceil(
              this.totalCounters / this.countElements
            );

            let counters = response.data.results;

            counters.forEach((counter) => {
              counter.indications.forEach((indication) => {
                indication.date_created = DateTime.fromISO(
                  indication.date_created
                ).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
              });
              counter.kind = meterType.find((x) => x.id == counter.kind);
              counter.status = counterStatus.find(
                (x) => x.id == counter.status
              );
              counter.home.county_type = countyType.find(
                (x) => x.id == counter.home.county_type
              );
            });

            this.counters = counters;
          })
          .catch((error) => {});

        this.$vs.loading.close();
      });
    },
    openDeleteCounter(idCounter) {
      this.counter = this.counters.find((x) => x.id == idCounter);
      this.popupDeleteComfirm = true;
    },
    deleteCounter() {
      this.$load(async () => {
        await this.$api.counters
          .deleteCounter(this.counter.id)
          .then((response) => {
            let item = this.counters.find((x) => x.id == this.counter.id),
              index = this.counters.indexOf(item);

            if (index !== -1) {
              this.counters.splice(index, 1);
            }
            this.popupDeleteComfirm = false;
            this.clearCounter();
            this.notification("Успешно", "Счетчик удален", "success");
          })
          .catch((error) => {
            this.notification("Ошибка", "Счетчик не удалось удалить", "danger");
          });
      });
    },
    openEditCounter(idCounter) {
      this.getHomes();
      this.counter = this.counters.find((x) => x.id == idCounter);
      this.popupEditCounter = true;
    },
    updateCounter() {
      let payload = {
        counter_number: this.counter.counter_number,
        status: this.counter.status.id,
        home: this.counter.home.id,
      };

      this.$vs.loading();

      this.$load(async () => {
        await this.$api.counters
          .updateCounter(this.counter.id, payload)
          .then((response) => {
            this.notification("Успешно", "Счетчик успешно обновлен", "success");
            this.popupEditCounter = false;
            this.clearCounter();
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Счетчик не удалось обновить",
              "danger"
            );
          });
        this.$vs.loading.close();
      });
    },
    clearCounter() {
      this.counter = null;
    },
    clearNewIndication() {
      this.newIndication = null;
    },

    //Homes
    filterHomes: _.debounce(function () {
      this.currentPagingationPageHomes = 1;
      this.getHomes();
    }, 1000),
    ifHomeSelected(idHome) {
      return this.counter.home.id !== idHome;
    },
    getHomes() {
      this.$vs.loading();

      this.filterForHomes.page = this.currentPagingationPageHomes;
      this.filterForHomes.limit = 10;

      this.$load(async () => {
        await this.$api.homes
          .getHomes(this.filterForHomes)
          .then((res) => {
            this.totalHomes = res.data.count;

            this.totalPagePaginationHomes = Math.ceil(
              this.totalHomes / this.filterForHomes.limit
            );

            let homes = res.data.results;

            homes.forEach((home, i) => {
              home.county_type = countyType.find(
                (x) => x.id == home.county_type
              );
            });

            this.homes = homes;
            this.$vs.loading.close();
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close();
          });
      });
    },
  },
  mounted() {
    this.getCounters();
  },
};
</script>